import {PollResultsUpdate} from './PollResultsUpdate.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';

export class PollResultsUpdateContainer {
	constructor() {
		let [css, _] = PollRobotTemplate(`PollResultsUpdateContainer-css`);
		document.head.appendChild(css);
		[this.el, this.$] = PollRobotTemplate(`PollResultsUpdateContainer`);
		document.body.appendChild(this.el);
		this.el.addEventListener(`pollrobot-close-poll`, evt=>this.closePoll(evt));
		this.listeners = [];
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(m => m!=l);
	}
	closePoll(evt) {
		evt.stopPropagation();
		this.listeners.map(l => l.update_container_close_poll(evt.detail.pollId, evt.detail.askId));
		this.resultsUpdate.close();
	}
	showLiveResults(js) {
		if (this.resultsUpdate) {
			this.resultsUpdate.close();
		}
		this.el.innerHtml = ``;
		this.resultsUpdate = new PollResultsUpdate(this.el, js);
	}
}